var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prediction-basic-from" },
    [
      _c(
        "el-form",
        {
          staticClass: "section",
          staticStyle: { "flex-direction": "row" },
          attrs: { disabled: _vm.readonly, "label-width": "125px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
            [
              _c("el-input", {
                attrs: { disabled: true, no: "jobNo" },
                model: {
                  value: _vm.job.jobNo,
                  callback: function($$v) {
                    _vm.$set(_vm.job, "jobNo", $$v)
                  },
                  expression: "job.jobNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.CustomerReferenceNumber") } },
            [
              _c("cargo-input", {
                attrs: { no: "customerRefNo", trim: true },
                model: {
                  value: _vm.job.customerRefNo,
                  callback: function($$v) {
                    _vm.$set(_vm.job, "customerRefNo", $$v)
                  },
                  expression: "job.customerRefNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class: _vm.poNoRed ? "poNoClass" : "",
              attrs: { label: _vm.$t("SeaExport.ItemNo") }
            },
            [
              _c("cargo-input", {
                attrs: { no: "poNo" },
                model: {
                  value: _vm.job.poNo,
                  callback: function($$v) {
                    _vm.$set(_vm.job, "poNo", $$v)
                  },
                  expression: "job.poNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.InputDate2") } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "175px" },
                attrs: {
                  type: "date",
                  no: "inputDate",
                  "value-format": "yyyy-MM-dd",
                  disabled: true
                },
                model: {
                  value: _vm.inputDate,
                  callback: function($$v) {
                    _vm.inputDate = $$v
                  },
                  expression: "inputDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "basicForm",
          staticStyle: { display: "flex", height: "100%" },
          attrs: {
            disabled: _vm.readonly,
            "label-position": "right",
            "label-width": _vm.isZh ? "135px" : "160px"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "fit-content",
                display: "flex",
                height: "fit-content"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "section form-column",
                  staticStyle: { "min-height": "635px", width: "349px" }
                },
                [
                  _vm.isZY
                    ? [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AllowSaleProduct,
                                filterable: "",
                                no: "allowSaleProduct",
                                clearable: "",
                                "data-filter-function": function(p) {
                                  return p.statusEnabled && p.seaImportEnabled
                                },
                                "default-value": _vm.job.saleProductCode || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.saleProductCode = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_FullOrInside$FULL_OR_INSIDE,
                                no: "fullOrInside",
                                clearable: "",
                                "default-value": _vm.job.fullOrInside || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.fullOrInside = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: _vm.isCrossTenantSEToSI,
                            no: "cargoSource",
                            placeholder: _vm.$t("SeaExport.PleaseSelect")
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.cargoSourceChange(p)
                            }
                          },
                          model: {
                            value: _vm.job.cargoSource,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoSource", $$v)
                            },
                            expression: "job.cargoSource"
                          }
                        },
                        _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customJobType",
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          "method-params": { type: "SI", active: true },
                          "callback-method-type": "value",
                          "default-value": _vm.job.customJobType,
                          "callback-params": { key: "customJobType" }
                        },
                        on: {
                          parentCallBack: function(val) {
                            _vm.job.customJobType = val.value
                            _vm.onCustomJobTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.visibleDesignationAgent,
                          expression: "visibleDesignationAgent"
                        }
                      ],
                      staticClass: "required",
                      attrs: { label: _vm.$t("SeaExport.NominatedAgent") }
                    },
                    [
                      _c("cargo-company-select", {
                        ref: "designationAgent",
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "designationAgent",
                          "method-params": {
                            designationAgent: true,
                            active: true
                          },
                          "default-value": _vm.job.designationAgent || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.designationAgentChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.visibleDesignationAgent,
                          expression: "visibleDesignationAgent"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.PortOfLoadingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "destinationAgent",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { overseaAgent: true, active: true },
                          "default-value": _vm.job.destinationAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.txtDestinationAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: {
                        label: _vm.visibleDesignationAgent
                          ? _vm.$t("SeaExport.ActualNotifyParty")
                          : _vm.$t("SeaExport.ConsignationCompany")
                      }
                    },
                    [
                      _c("cargo-sales-company-select", {
                        attrs: {
                          no: "customerId",
                          "method-params": {
                            customer: true,
                            active: true,
                            companyLob: "seaImport"
                          },
                          "default-value": _vm.job.customerId || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.customerIdChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ContactPerson") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "customerContact",
                            filterable: "",
                            "allow-create": true
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.customerContactChange()
                            }
                          },
                          model: {
                            value: _vm.job.customerContact,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customerContact", $$v)
                            },
                            expression: "job.customerContact"
                          }
                        },
                        _vm._l(_vm.contactList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.contactPerson,
                              value: item.contactPerson
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowContactPersonDetail,
                          expression: "!isShowContactPersonDetail"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.Tel") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "contactTelephone" },
                        model: {
                          value: _vm.job.contactTelephone,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "contactTelephone", $$v)
                          },
                          expression: "job.contactTelephone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowContactPersonDetail,
                          expression: "!isShowContactPersonDetail"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.Fax") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "contactFax" },
                        model: {
                          value: _vm.job.contactFax,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "contactFax", $$v)
                          },
                          expression: "job.contactFax"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.visibleDesignationAgent,
                          expression: "!visibleDesignationAgent"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.PortOfLoadingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "destinationAgent",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { overseaAgent: true, active: true },
                          "default-value": _vm.job.destinationAgent || "",
                          disabled: _vm.isCrossTenantSEToSI
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.txtDestinationAgentChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isCrossTenantSEToSI
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.ConsignationRelationNumber"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "trustFromJob",
                              value: _vm.job.trustFromJob,
                              disabled: true
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ShippingCompany") } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carrierId",
                          "method-params": {
                            companyLob: "seaImport",
                            seaCmp: true,
                            active: true
                          },
                          "default-value": _vm.job.carrierId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.carrierId = p.value
                            _vm.onCarrierIdChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Mbl2") } },
                    [
                      _c("cargo-input", {
                        attrs: {
                          "auto-uppercase": true,
                          disabled: _vm.isCrossTenantSEToSI,
                          no: "mbl"
                        },
                        model: {
                          value: _vm.job.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "mbl", $$v)
                          },
                          expression: "job.mbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Hbl2") } },
                    [
                      _c("cargo-input", {
                        attrs: {
                          "auto-uppercase": true,
                          disabled: _vm.isCrossTenantSEToSI,
                          no: "hbl"
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.hblFunction($event)
                          }
                        },
                        model: {
                          value: _vm.job.hbl,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "hbl", $$v)
                          },
                          expression: "job.hbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                    [
                      _c("cargo-input", {
                        attrs: {
                          "auto-uppercase": true,
                          disabled: _vm.isCrossTenantSEToSI,
                          no: "vessel"
                        },
                        model: {
                          value: _vm.job.vessel,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "vessel", $$v)
                          },
                          expression: "job.vessel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                    [
                      _c("cargo-input", {
                        attrs: {
                          "auto-uppercase": true,
                          disabled: _vm.isCrossTenantSEToSI,
                          no: "voyageFlight"
                        },
                        on: { focus: _vm.loadVoyageFlight },
                        model: {
                          value: _vm.job.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "voyageFlight", $$v)
                          },
                          expression: "job.voyageFlight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                    [
                      _c("cargo-input", {
                        attrs: {
                          "auto-uppercase": true,
                          no: "dispatchingPlace"
                        },
                        model: {
                          value: _vm.job.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "dispatchingPlace", $$v)
                          },
                          expression: "job.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: { label: _vm.$t("SeaExport.PortOfLoading") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "loadingPortCode",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          "default-value": _vm.job.loadingPortCode,
                          disabled: _vm.isCrossTenantSEToSI
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.loadingPortCodeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: { label: _vm.$t("SeaExport.PortOfDischarge") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "dischargingPortCode",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          "default-value": _vm.job.dischargingPortCode,
                          disabled: _vm.isCrossTenantSEToSI
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.job.dischargingPortCode = p.value
                            _vm.pm.dischargingPortCodeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: { label: _vm.$t("SeaExport.PlaceOfDelivery") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationPortCode",
                          disabled: _vm.readonly,
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.destinationPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.destinationPortCode = p.value
                            _vm.pm.destinationPortCodeEasyChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FinalDestination") } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.isCrossTenantSEToSI,
                          no: "destinationPlace"
                        },
                        model: {
                          value: _vm.job.destinationPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "destinationPlace", $$v)
                          },
                          expression: "job.destinationPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationWay")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customClaim",
                          filterable: "",
                          disabled: _vm.readonly,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_AirExportConstants$CUSTOM_CLAIMS,
                          "default-value":
                            _vm.job.customClaim === -1
                              ? ""
                              : _vm.job.customClaim,
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          "tag-value": "code",
                          "zero-can-copy": true,
                          fields: [_vm.isZh ? "chineseName" : "englishName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customClaim = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.job.customClaim === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationType")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsDeclarationType",
                              disabled: _vm.readonly,
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_CustomsDeclarationType,
                              filterable: "",
                              "default-value":
                                _vm.job.customsDeclarationType === -1
                                  ? ""
                                  : _vm.job.customsDeclarationType,
                              placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customsDeclarationType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Message.TerminalCompany") } },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "terminalCompany",
                          disabled: _vm.readonly,
                          "method-params": {
                            terminalCompany: true,
                            companyLob: "seaImport",
                            active: true
                          },
                          "default-value": _vm.job.terminalCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.terminalCompanyChangeHandler(
                              _vm.job,
                              p
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Message.DeliveryAddress") } },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "deliveryAddress",
                          disabled: _vm.readonly
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("Message.DeliveryAddress"),
                              _vm.job.deliveryAddress,
                              function(val) {
                                _vm.job.deliveryAddress = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.deliveryAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "deliveryAddress", $$v)
                          },
                          expression: "job.deliveryAddress"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "section form-column",
                  staticStyle: { "min-height": "635px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DateOfDeparture") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "etd",
                          type: "date",
                          clearable: "",
                          disabled: _vm.isCrossTenantSEToSI,
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.job.etd,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "etd", $$v)
                          },
                          expression: "job.etd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ExpectedArrivalDate") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "eta",
                          type: "date",
                          clearable: "",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.job.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "eta", $$v)
                          },
                          expression: "job.eta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ActualDateOfArrival") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "ata",
                          type: "date",
                          clearable: "",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.job.ata,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "ata", $$v)
                          },
                          expression: "job.ata"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ArrivalTime2") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "arrivalTime",
                          disabled: _vm.readonly,
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.job.arrivalTime,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "arrivalTime", $$v)
                          },
                          expression: "job.arrivalTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "flex-end"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: _vm.readonly,
                              no: "otherBill"
                            },
                            on: { click: _vm.onExcerption }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: _vm.readonly,
                              no: "codeSearching"
                            },
                            on: { click: _vm.onCodeSearch }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Shipper") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-input", {
                            staticStyle: {
                              width: "80px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              no: "shipperCode",
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("SeaExport.Code2"),
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            model: {
                              value: _vm.job.shipperCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "shipperCode", $$v)
                              },
                              expression: "job.shipperCode"
                            }
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "shipperLine1",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.BillsOfLadingDoubleClickEject"
                                  )
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "shipper",
                                  6,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.job.shipperLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "shipperLine1", $$v)
                              },
                              expression: "job.shipperLine1"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Consignee") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-input", {
                            staticStyle: {
                              width: "80px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              no: "consigneeCode",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("SeaExport.Code2"),
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.qConsigneeCode_focusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.job.consigneeCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeCode", $$v)
                              },
                              expression: "job.consigneeCode"
                            }
                          }),
                          _c("cargo-input", {
                            attrs: {
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              no: "consigneeLine1",
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.BillsOfLadingDoubleClickEject"
                                  )
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.qConsigneeAddr_focusOutHandler()
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "consignee",
                                  6,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.job.consigneeLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "consigneeLine1", $$v)
                              },
                              expression: "job.consigneeLine1"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.NotifyParty") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-input", {
                            staticStyle: {
                              width: "80px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              no: "notifyCode",
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t("SeaExport.Code2"),
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            model: {
                              value: _vm.job.notifyCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyCode", $$v)
                              },
                              expression: "job.notifyCode"
                            }
                          }),
                          _c("cargo-input", {
                            attrs: {
                              no: "notifyLine1",
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.BillsOfLadingDoubleClickEject"
                                  )
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showSenderAndReceiverDialog(
                                  "notify",
                                  6,
                                  false,
                                  _vm.notUppercaseShipperConsigneNotify
                                )
                              }
                            },
                            model: {
                              value: _vm.job.notifyLine1,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "notifyLine1", $$v)
                              },
                              expression: "job.notifyLine1"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ActualQuantity") } },
                    [
                      _c("auto-number-input", {
                        attrs: {
                          no: "quantityContract",
                          precision: 0,
                          min: 0,
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.quantityChange()
                          }
                        },
                        model: {
                          value: _vm.job.quantityActual,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "quantityActual", $$v)
                          },
                          expression: "job.quantityActual"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Package") } },
                    [
                      _c("cargo-packing-select", {
                        attrs: {
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                          no: "packing",
                          "default-value": _vm.job.packing
                        },
                        on: {
                          change: function(p) {
                            _vm.job.packing = p.value
                            _vm.pm.chargePacking()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ActualWeight") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "weightContract",
                              precision: 3,
                              min: 0,
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.weightChange()
                              }
                            },
                            model: {
                              value: _vm.job.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "weightActual", $$v)
                              },
                              expression: "job.weightActual"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ActualVolume") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "cubageContract",
                              precision: 3,
                              min: 0,
                              disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.cubageChange()
                              }
                            },
                            model: {
                              value: _vm.job.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "cubageActual", $$v)
                              },
                              expression: "job.cubageActual"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ChargedWeight") } },
                    [
                      _c("auto-number-input", {
                        attrs: {
                          no: "chargeWeight",
                          precision: 3,
                          min: 0,
                          disabled: _vm.isCrossTenantSEToSI
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.chargeWeightChangeHandler()
                          }
                        },
                        model: {
                          value: _vm.job.chargeWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "chargeWeight", $$v)
                          },
                          expression: "job.chargeWeight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "cargoChineseName",
                          "text-chars": 0,
                          "warning-count": 45,
                          "auto-uppercase": true,
                          disabled: _vm.readonly
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.job.cargoChineseName,
                              function(val) {
                                _vm.job.cargoChineseName = val
                              },
                              false,
                              { warningCount: 45, maxChar: 0 }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoChineseName", $$v)
                          },
                          expression: "job.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "cargoEnglishName",
                          "text-chars": 0,
                          "warning-count": 45,
                          "auto-uppercase": _vm.isUppercaseByConfig,
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                              _vm.job.cargoEnglishName,
                              function(val) {
                                _vm.job.cargoEnglishName = val
                              },
                              false,
                              { warningCount: 45, maxChar: 0 },
                              _vm.isUppercaseByConfig
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoEnglishName", $$v)
                          },
                          expression: "job.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeTerms") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          disabled: _vm.readonly || _vm.isCrossTenantSEToSI,
                          no: "incoTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          "method-params": {},
                          "callback-method-type": "value",
                          "default-value": _vm.job.incoTerm + "",
                          "callback-params": { key: "incoTerm" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section form-column",
                  staticStyle: { "min-height": "635px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.MblNo4") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "masterJobNo" },
                        model: {
                          value: _vm.job.masterJobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "masterJobNo", $$v)
                          },
                          expression: "job.masterJobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FLCLType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "containerLoadType",
                          filterable: "",
                          clearable: false,
                          disabled: _vm.isCrossTenantSEToSI,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_ImportConstants$_cargoTypeInputList,
                          "default-value": _vm.job.containerLoadType,
                          "tag-name":
                            _vm.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.cargoTypeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.TransportationClause") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "freightTermHBL",
                          filterable: "",
                          clearable: false,
                          disabled: _vm.isCrossTenantSEToSI,
                          "select-type":
                            _vm.selectTypeNames.basic_data_ShippingTerm,
                          "default-value": _vm.job.freightTermHBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.freightTermHBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          filterable: "",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoType,
                          "default-value": _vm.job.cargoType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoType = p.value
                            _vm.onCargoTypeChagne()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HBLFreightClause") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentTermHBL",
                          filterable: "",
                          clearable: false,
                          disabled: _vm.isCrossTenantSEToSI,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          "default-value": _vm.job.paymentTermHBL,
                          "callback-params": { key: "paymentTermHBL" }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentTermHBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.MasterBLFreightTerm") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentTermMBL",
                          filterable: "",
                          clearable: false,
                          disabled: _vm.isCrossTenantSEToSI,
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          "default-value": _vm.job.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentTermMBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.HblCargoReleaseWay") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "releaseTypeHbl",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_ImportConstants$_importReleaseTypes,
                          "callback-method-type": "value",
                          "default-value": _vm.job.releaseTypeHbl,
                          headers: [_vm.$t("Tool.Code")],
                          fields: ["code"],
                          "tag-name":
                            _vm.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          "callback-params": { key: "releaseTypeHBL" }
                        },
                        on: {
                          parentCallBack: function(val) {
                            _vm.job.releaseTypeHbl = val.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HarborDistrict") } },
                    [
                      _c("cargo-input", {
                        attrs: { "auto-uppercase": true, no: "portDistrict" },
                        model: {
                          value: _vm.job.portDistrict,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "portDistrict", $$v)
                          },
                          expression: "job.portDistrict"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.containerLoadType !== "LCL",
                          expression: "job.containerLoadType!=='LCL'"
                        }
                      ],
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("booking-sea-eq-data-grid", {
                        attrs: {
                          value: _vm.seaEqList,
                          "is-edit": _vm.isEdit,
                          job: _vm.job
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          no: "remarks",
                          disabled: _vm.readonly,
                          "is-trim": true
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.job.remarks,
                              function(val) {
                                _vm.job.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section form-column",
                  staticStyle: { "min-height": "635px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesCompany") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true, no: "txtSalesOffice" },
                        model: {
                          value: _vm.txtSalesOffice,
                          callback: function($$v) {
                            _vm.txtSalesOffice = $$v
                          },
                          expression: "txtSalesOffice"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                      ),
                      _c("cargo-user-select", {
                        ref: "sales",
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "sales",
                          "method-params": {
                            officeId: _vm.salesOfficeCheck
                              ? _vm.$store.getters.currentOfficeId
                              : "",
                            category: "role",
                            shape: "sales"
                          },
                          "default-value": _vm.job.sales || "",
                          "static-options": _vm.salesList,
                          placeholder: _vm.salesPrompt
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.salesChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.job.cargoSalesId || "",
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.job.cargoSalesId = p.value
                            _vm.pm.cargoSalesChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesDepartment") } },
                    [
                      _c("cargo-department-new-select", {
                        attrs: {
                          disabled: !_vm.job.sales,
                          no: "salesOffice",
                          "sales-id": Number(_vm.job.sales),
                          enables: true,
                          "office-id": _vm.job.salesOffice,
                          "department-id": Number(_vm.job.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.salesDepartmentChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: _vm.readonly || _vm.opOfficeDisabled,
                          no: "opOffice",
                          "static-options": _vm.cacheOffices,
                          "select-type": _vm.selectTypeNames.basic_data_Office,
                          filterable: "",
                          "default-value": _vm.job.opOffice
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.opOffice = p.value
                            _vm.job.opDepartment = 0
                            _vm.opOfficeChargeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: { label: _vm.$t("SeaExport.OperationDepartment") }
                    },
                    [
                      _c("cargo-department-select", {
                        ref: "department",
                        attrs: {
                          no: "opDepartment",
                          "office-id": Number(_vm.job.opOffice),
                          enables: true,
                          "department-id": Number(_vm.job.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "op",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "siop"
                          },
                          "default-value": _vm.job.op || "",
                          "static-options": _vm.userPortRoleData.op
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.opChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrOffice = p.value
                            _vm.job.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("Message.Customer_Service")))
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.job.csrOffice),
                          disabled: _vm.readonly,
                          enables: true,
                          "department-id": Number(_vm.job.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "csr",
                          "method-params": {
                            category: "role",
                            shape: "csr",
                            officeId: _vm.job.salesOffice
                              ? _vm.job.salesOffice === 1
                                ? _vm.job.opOffice
                                : _vm.job.salesOffice
                              : null
                          },
                          "default-value": _vm.job.csr || "",
                          "static-options": _vm.userPortRoleData.csr
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcOffice = p.value
                            _vm.job.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("Message.Documentation_Department"))
                        )
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.job.dcOffice),
                          disabled: _vm.readonly,
                          enables: true,
                          "department-id": Number(_vm.job.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "dc",
                          "method-params": {
                            category: "role",
                            shape: "doc",
                            officeId: _vm.job.opOffice
                          },
                          "default-value": _vm.job.dc || "",
                          "static-options": _vm.userPortRoleData.doc
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "plannerOffice",
                          disabled: true,
                          "office-id": Number(_vm.job.plannerOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerOffice = p.value
                            _vm.job.plannerDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.AirlineDepartment")))
                      ]),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "plannerDepartment",
                          "office-id": Number(_vm.job.plannerOffice),
                          disabled: _vm.readonly,
                          enables: true,
                          "department-id": Number(_vm.job.plannerDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.plannerDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlinePerson") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            category: "role",
                            shape: "sealine",
                            officeId: _vm.job.opOffice
                          },
                          "default-value": _vm.job.planner || "",
                          "static-options": _vm.userPortRoleData.seaLine
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.plannerChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "siteOP",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.job.siteOP || "",
                          "static-options": _vm.userPortRoleData.siteOp
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "overseaOp",
                        staticClass: "input2",
                        attrs: {
                          no: "overseaOp",
                          "default-value": _vm.job.overseaOp || "",
                          "method-params": {
                            category: "role",
                            shape: "overseaOp"
                          },
                          "static-options": _vm.isHC
                            ? null
                            : _vm.userPortRoleData.overseaOp ||
                              _vm.overseaAgentUsersList,
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.job.overseaOp = p.value
                            _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                              _vm.view,
                              p
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxNature", $$v)
                            },
                            expression: "job.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c("import-prompt-title-dialog", {
        attrs: {
          visible: _vm.importPromptTitleDialog.visible,
          lob: _vm.job.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.importPromptTitleDialog, "visible", $event)
          },
          selected: _vm.onExcerptionChangeFunc
        }
      }),
      _c("import-bill-address-title-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "198px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.advanceTextDialog.visible,
                      expression: "advanceTextDialog.visible"
                    }
                  ],
                  attrs: { type: "primary", no: "confirm" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }